import { render, staticRenderFns } from "./BillingAddressUpdated.vue?vue&type=template&id=0b56c0d7&scoped=true"
import script from "./BillingAddressUpdated.vue?vue&type=script&lang=js"
export * from "./BillingAddressUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56c0d7",
  null
  
)

export default component.exports